import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PipeTransform, Pipe, Injectable } from '@angular/core';

@Pipe({ name: 'safeHtml', standalone: true })
@Injectable({ providedIn: 'root' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: any): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(value || '');
  }
}
